import { useEffect, useState } from "react";
import api from "../lib/api";
import { ui, SECTION_TAG_LABELS } from "../lib/ui";
import { Link } from "react-router-dom";
import { TrendingUp, Repeat } from "lucide-react";

export default function TrendingTerms({ section = "", title = "Trending topics" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/reports/trending", { params: { section } })
      .then((r) => setItems(r.data.items))
      .catch(() => setItems([]));
  }, [section]);

  if (items.length === 0) return null;

  return (
    <div className={ui.card + " p-5"} data-testid="trending-panel">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp size={18} className="text-[#8B1A1A]" />
        <h3 className="font-serif text-lg font-semibold text-[#8B1A1A]">{title}</h3>
      </div>
      <div className="space-y-2.5">
        {items.map((it, i) => (
          <div
            key={i}
            className="flex items-start gap-3 rounded-xl border border-[#E8DCC8] bg-[#FFFDF9] px-4 py-3"
            data-testid="trending-topic"
          >
            <div className="flex-1 min-w-0">
              {!section && (
                <span className={ui.pill + " mb-1.5"}>{SECTION_TAG_LABELS[it.code] || it.label}</span>
              )}
              <p className="text-[#210201] text-sm leading-snug">{it.topic}</p>
            </div>
            <span
              className="shrink-0 inline-flex items-center gap-1 bg-[#8B1A1A] text-[#F5EAE0] text-xs font-semibold px-2.5 py-1 rounded-full"
              title={`Reported ${it.count} times`}
            >
              <Repeat size={12} /> {it.count}×
            </span>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#5A4441] mt-3">
        Topics reported by multiple candidates{section ? " in this section" : ""}. <Link to="/archive" className="text-[#8B1A1A] underline">Browse all →</Link>
      </p>
    </div>
  );
}
